import React from 'react';
import { Separator } from '@/components/ui/separator';
import { FREELANCER_PLAN, ORGANIZATION_PLAN } from '@/config/tierPricing';

export default function OrderSummary({ isFreelancer, tier, units }) {
  const total = isFreelancer
    ? `SGD $${FREELANCER_PLAN.priceSgd.toFixed(2)}/mo`
    : `SGD $${ORGANIZATION_PLAN.onboardingSgd.toLocaleString(undefined, { minimumFractionDigits: 2 })}/yr`;

  return (
    <div className="bg-slate-50 p-4 rounded-lg space-y-2" data-testid="signup-order-summary">
      <div className="flex justify-between text-sm">
        <span>Plan</span>
        <span className="font-medium">{isFreelancer ? FREELANCER_PLAN.name : (tier?.name || '')}</span>
      </div>
      <Separator />
      <div className="flex justify-between font-medium">
        <span>{isFreelancer ? 'Total (Monthly)' : 'Total (Annual)'}</span>
        <span className="text-primary" data-testid="signup-order-total">{total}</span>
      </div>
      {!isFreelancer && units > 1 && (
        <p className="text-xs text-muted-foreground">
          {units} units x {tier?.userCap} users = {((tier?.userCap || 0) * units).toLocaleString()} users
        </p>
      )}
    </div>
  );
}
